import { Box, Collapse } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { NavIcon } from './NavIcon'

const EgretVerticalNavExpansionPanel = (props) => {
  const { classes, children, item } = props
  const { name, icon, badge, iconPath, iconText } = item
  const [collapsed, setCollapsed] = useState(false)
  const elementRef = useRef(null)
  const location = useLocation()

  useEffect(() => {
    if (elementRef.current) {
      // OPEN DROPDOWN IF CHILD IS ACTIVE
      for (const child of elementRef.current.children) {
        if (child.getAttribute('href') === location.pathname) {
          setCollapsed(false)
        }
      }
    }
  }, [location.pathname])

  const childrenLength = children?.length || 0

  let enterDuration = 500 * (childrenLength) / 14
  enterDuration = enterDuration < 250 ? 250 : enterDuration
  let exitDuration = 350 * (childrenLength) / 14
  exitDuration = exitDuration < 250 ? 250 : exitDuration

  if (item.path) {
    return (
      <div className={`nav-expansion-panel ${collapsed ? '' : 'expanded'}`}>
        <NavLink to={item?.path} className='nav-item top-level'>
          <Box
            className='nav-item flex-middle h-48 w-100 top-level'
            sx={{ padding: '9px 22px' }}
          >
            <div className='flex flex-middle' style={{flexGrow: 1}}>
              <NavIcon item={{ icon, iconPath, iconText }} />
              <span className='text-middle nav-item-text' style={{ paddingLeft: 10 }}>
                {name}
              </span>
            </div>
            {/* {badge && (
            <div className={`badge bg-${badge.color}`}>{badge.value}</div>
          )} */}
            {/* <div
            className={
              collapsed
                ? classes.collapseIcon + ' item-arrow'
                : classes.expandIcon + ' item-arrow'
            }
          >
            <Icon className='text-middle'>chevron_right</Icon>
          </div> */}
          </Box>

        </NavLink>

        <Collapse in={!collapsed} timeout={{ enter: enterDuration, exit: exitDuration }} easing='ease-in-out'>
          <div ref={elementRef}>
            {children}
          </div>
        </Collapse>
      </div>
    )
  }

  return (
    <div className={`nav-expansion-panel ${collapsed ? '' : 'expanded'}`}>

      <Box
        className='nav-item flex-middle h-48 w-100 top-level'
        sx={{ padding: '9px 22px' }}
      >
        <div className='flex flex-middle'  style={{flexGrow: 1}}>
          <NavIcon item={{ icon, iconPath, iconText }} />
          <span className='text-middle nav-item-text' style={{ paddingLeft: 10 }}>
            {name}
          </span>
        </div>
        {/* {badge && (
          <div className={`badge bg-${badge.color}`}>{badge.value}</div>
        )} */}
        {/* <div
          className={
            collapsed
              ? classes.collapseIcon + ' item-arrow'
              : classes.expandIcon + ' item-arrow'
          }
        >
          <Icon className='text-middle'>chevron_right</Icon>
        </div> */}
      </Box>

      <Collapse in={!collapsed} timeout={{ enter: enterDuration, exit: exitDuration }} easing='ease-in-out'>
        <div ref={elementRef}>
          {children}
        </div>
      </Collapse>
    </div>
  )
}

export default EgretVerticalNavExpansionPanel
